var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeaderboardsOrganizationChallenge = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _spraypaint = require("spraypaint");
var _Leaderboard2 = require("./Leaderboard");
var _dec, _class, _class2;
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var LeaderboardsOrganizationChallenge = exports.LeaderboardsOrganizationChallenge = (_dec = (0, _spraypaint.Model)(), _dec(_class = (_class2 = function (_Leaderboard) {
  (0, _inherits2["default"])(LeaderboardsOrganizationChallenge, _Leaderboard);
  var _super = _createSuper(LeaderboardsOrganizationChallenge);
  function LeaderboardsOrganizationChallenge() {
    (0, _classCallCheck2["default"])(this, LeaderboardsOrganizationChallenge);
    return _super.apply(this, arguments);
  }
  return (0, _createClass2["default"])(LeaderboardsOrganizationChallenge);
}(_Leaderboard2.Leaderboard), (0, _defineProperty2["default"])(_class2, "endpoint", '/leaderboards/challenge_members'), (0, _defineProperty2["default"])(_class2, "jsonapiType", 'challenge_members'), _class2)) || _class);